import { IQuickFind } from '@ifit/gateway-wolf-dashboard-service';
import CardQuickFind from '@ifit/mp-quick-find';
import { getUserNavigationHandler, ROWTITLES } from '../../util/navigation-utils';

interface IQuickFindItemProps {
  item: IQuickFind;
}

export default function QuickFindItem({ item }: IQuickFindItemProps): JSX.Element {
  const clickHandler = getUserNavigationHandler(item.url, ROWTITLES.QUICK_FIND_ITEM);
  return <CardQuickFind title={item.title} onClick={clickHandler} />;
}
